import React from 'react';
import "./ContentTwoColumns.scss"
 

function ContentTwoColumns ({
    leftContentMaxWidth,
    rightContentMaxWidth,
    leftContent,
    rightContnet
}){
    
    // document.documentElement.style.setProperty('--leftContentMaxWidth', leftContentMaxWidth);
	return (
        <>
            <div className="ContentTwoColumns-container">
                <div className={"ContentTwoColumns-left " + (leftContentMaxWidth ? "leftContentMaxWidth_" + leftContentMaxWidth : "")}>
                    {leftContent}
                </div>
                <div className={"ContentTwoColumns-right " + (rightContentMaxWidth ? "rightContentMaxWidth_" + rightContentMaxWidth : "")}>
                    {rightContnet}
                </div>
            </div>

            </>
	)
}

export default ContentTwoColumns;
